<template>
  <div :class="[language === 'cn' ? 'font-cn' : 'font-en']">
    <!--===== SLIDER =====-->
    <div class="slider">
      <!-- List Items -->
      <div class="list">
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="['item', { active: index === itemActive }]"
        >
          <img :src="item.img" />
          <div class="content">
            <!-- <p>{{ item.description }}</p> -->
            <p>{{ item.design }}</p>
            <h2>{{ item.title }}</h2>
          </div>
        </div>
      </div>

      <!-- Button Arrows -->
      <div v-show="arrowsSwitch" class="arrows">
        <button @click="prev">&lt;</button>
        <button @click="next">&gt;</button>
      </div>

      <!-- Thumbnail -->
      <div class="thumbnail"> 
        <div
          v-for="(item, index) in items"
          :key="index"
          :class="['item', { active: index === itemActive }]"
          @click="setActive(index)"
        >
          <img :src="item.img" />
          <!-- Name Slider Homepage -->
          <div class="content"></div>
        </div>
      </div>
    </div>

    <!-- ==== 行业领域  industry_area ==== -->
    <section class="skills section" id="industry_area">
      <div class="homepage_industry_area_container">
        <router-link to="industryarea"
          ><div class="industry_area_header">
            {{ content.industry_area_title }}
          </div></router-link
        >
        <div class="industry_area_grid">
          <router-link
            v-for="(area, index) in content.industry_area"
            :key="index"
            :to="{ path: area.link.path, query: { sector: area.id } }"
            class="industry_area_grid_item"
          >
            <img :src="area.image" class="industry_area_img"/>
            <div class="overlay">{{ area.title }}</div>
          </router-link>
        </div>
      </div>
    </section>

    <!--===== 案例展示 cases =====-->
    <section class="planandcases section" id="planandcases">
      <div class="cases_container">
        <div class="cases_header">{{ content.plan_and_cases_title }}</div>
        <div class="cases_grid">
          <!-- First row: 1 large item -->
          <div class="cases_grid_item span-two-columns">
            <router-link
              v-for="(area, index) in content.plan_and_cases_1"
              :key="index"
              :to="area.link"
              class="cases_image"
            >
              <img :src="area.image" class="cases_img" />
              <span class="image_text">
                <p>{{ area.p1 }}</p>
                <p>{{ area.p2 }}</p>
              </span>
            </router-link>
          </div>

          <!-- Second row: 1 large item, 2 small items -->
          <div class="cases_grid_item">
            <router-link
              v-for="(area, index) in content.plan_and_cases_2"
              :key="index"
              :to="area.link"
              class="cases_image"
            >
              <img :src="area.image" class="cases_img" />
              <span class="image_text">
                <p>{{ area.p1 }}</p>
                <p>{{ area.p2 }}</p>
                <p>{{ area.p3 }}</p>
              </span>
            </router-link>
          </div>

          <!-- Third row: Combined items 3, 4, and 5 -->
          <div
            class="cases_grid_item"
            v-for="(area, index) in content.plan_and_cases_345"
            :key="index"
          >
            <router-link :to="area.link" class="cases_image">
              <img :src="area.image" class="cases_img" />
              <span class="small_image_text">
                <p>{{ area.p1 }}</p>
                <p>{{ area.p2 }}</p>
              </span>
            </router-link>
          </div>
        </div>
        <div class="cases_footer">
          <router-link to="/planAndCases">更多&gt;&gt;&gt;</router-link>
        </div>
      </div>
    </section>

    <!--===== 新闻资讯 news ===== TODO: PICTURE ASPECT RATIO-->
    <section class="news section" id="news">
      <div class="news_container">
        <div class="news_header">{{ content.news_title }}</div>
        <div class="news_grid">
            <div class="news_grid_item_large">
                <router-link
                v-for="(area, index) in content.news_1"
                :key="index"
                :to="area.link"
                class="news_image_1"
              >
              <img :src="area.image" class="news_img" :ref="'largeImage' + index" />
                    <span class="image_text">
                        <p>{{area.p1}}</p>
                        <p>{{area.p2}}</p>
                    </span>
                </router-link>
            </div>
            <div class="news_grid_item_small">
                <router-link
                  v-for="(area, index) in content.news_2"
                  :key="index"
                  :to="area.link"
                  class="news_image"
                >
                <img :src="area.image" class="news_img" :ref="'smallImage' + index" />
                    <span class="small_image_text">
                        <p>{{area.p1}}</p>
                        <p>{{area.p2}}</p>
                    </span>
                </router-link>
            </div>
        </div>
        <div class="cases_footer">
          <router-link to="/news">更多&gt;&gt;&gt;</router-link>
        </div>
    </div>
    </section>
    <!--=========================== FOLLOW EACH ONE =================================-->
    <!-- <section class="news section" id="news">
      <div class="news_container">
        <div class="news_header">{{content.news_title}}</div>
        <div class="news_grid">
          <div class="news_grid_item large">
            <router-link v-for="(area, index) in content.news_1" :key="index" :to="area.link" class="news_image">
              <img :src="area.image" class="news_img">
              <span class="image_text">
                <p>{{ area.p1 }}</p>
                <p>{{ area.p2 }}</p>
              </span>
            </router-link>
          </div>
          <div class="news_grid_item small" v-for="(area, index) in content.news_2" :key="index">
            <router-link :to="area.link" class="news_image">
              <img :src="area.image" class="news_img">
              <span class="small_image_text">
                <p>{{ area.p1 }}</p>
                <p>{{ area.p2 }}</p>
                <p>{{ area.p3 }}</p>
              </span>
            </router-link>
          </div>
        </div>
        <div class="news_footer">
          <router-link to="/news">更多&gt;&gt;&gt;</router-link>
        </div>
      </div>
    </section> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import en from "@/data/homepage_en.js";
import cn from "@/data/homepage_cn.js";

export default {
  name: "AppHomepage",
  data() {
    return {
      items: [
        {
          img: require("../assets/img/Homepage/Cover/Homepage_sliderimg1.png"),
          title: `岩洞遗迹`,
          design: `行业领域：影视-虚拟制片`,
        },
        {
          img: require("../assets/img/Homepage/Cover/Homepage_sliderimg2.png"),
          title: `火星基地`,
          design: "行业领域：数字文旅-裸眼3D沉浸式体验",
        },
        {
          img: require("../assets/img/Homepage/Cover/Homepage_sliderimg3.png"),
          title: "赛博朋克",
          design: "行业领域：游戏-关卡美术场景",
        },
        {
          img: require("../assets/img/Homepage/Cover/Homepage_sliderimg4.jpg"),
          title: "王府园林",
          design: "行业领域：影视-虚拟制片",
        },
        
      ],
      itemActive: 0,
      refreshInterval: null,
      arrowsSwitch: true, // Default to true
    };
  },
  mixins: [en, cn],
  computed: {
    ...mapState(["language"]),
    content() {
      const defaultContent = { title: "", industry_areas: [] };
      const currentLanguage = this.language === "en" ? this.en : this.cn;
      console.log("Current Language:", currentLanguage); // Debug statement
      return currentLanguage || defaultContent;
    },
  },

  mounted() {
    this.startAutoRun();
    this.logImageDimensions();
  },
  beforeUnmount() {
    this.stopAutoRun();
  },
  methods: {
    ...mapMutations(["setLanguage"]),
    next() {
      this.itemActive = (this.itemActive + 1) % this.items.length;
    },
    prev() {
      this.itemActive =
        (this.itemActive - 1 + this.items.length) % this.items.length;
    },
    setActive(index) {
      this.itemActive = index;
      this.restartAutoRun();
    },
    startAutoRun() {
      this.refreshInterval = setInterval(this.next, 5000);
    },
    stopAutoRun() {
      clearInterval(this.refreshInterval);
    },
    restartAutoRun() {
      this.stopAutoRun();
      this.startAutoRun();
    },
    logImageDimensions() {
      // Log dimensions for large images
      this.content.news_1.forEach((area, index) => {
        const img = this.$refs[`largeImage${index}`][0];
        if (img) {
          img.addEventListener("load", () => {
            console.log(`Large Image ${index + 1}: Width = ${img.clientWidth}px, Height = ${img.clientHeight}px`);
          });
        }
      });

      // Log dimensions for small images
      this.content.news_2.forEach((area, index) => {
        const img = this.$refs[`smallImage${index}`][0];
        if (img) {
          img.addEventListener("load", () => {
            console.log(`Small Image ${index + 1}: Width = ${img.clientWidth}px, Height = ${img.clientHeight}px`);
          });
        }
      });
    },
  },

  watch: {
    "$route.query.arrowSwitch"(newVal) {
      this.arrowsSwitch = newVal === "true";
    },
    language(newValue) {
      console.log("Language changed to:", newValue); // Debug statement
      this.$forceUpdate(); // Force the component to re-render when the language changes
    },
  },
};
</script>
